import { Store } from '@ngrx/store'
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http'

import { Observable, throwError } from 'rxjs'
import { catchError, map, switchMap, tap } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { ShowSnackbar } from '../shared/shared.actions'
import { TranslateService } from '@ngx-translate/core'

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    public store: Store<any>,
    private router: Router,
    private translateService: TranslateService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((response: any) => {
        if (response.status === 200 && response.body.message) {
          this.store.dispatch(
            new ShowSnackbar({
              type: 'success',
              message: response.body.message,
            }),
          )
        }
      }),
      catchError((response: any) => {
        if (response instanceof HttpErrorResponse && response.status === 401) {
          localStorage.removeItem('token')
          this.router.navigate(['/auth/login'])
        } else if (response instanceof HttpErrorResponse) {
          this.store.dispatch(
            new ShowSnackbar({
              type: 'error',
              message: response.error.message
                ? response.error.message
                : this.translateService.instant('error.general'),
            }),
          )
        }
        return throwError(response)
      }),
    )
  }
}
